<template>
  <div v-if="visible">
    <div :style="{paddingBottom: '20px'}">{{ value.explain }}</div>
    <div
      :style="{fontSize: '17px',lineHeight: '35px'}"
      v-for="(items,i) in value.option"
      :key="i"
    >
      <p v-if="value.option.length > 1"> 第 {{ i + 1 }} 篇</p>
      <div :style="{backgroundColor: '#bfbfbf38',borderRadius: '5px'}">
        <div
          v-html="items.title"
          :style="{fontSize: '17px',lineHeight: '35px'}"
          class="ql-editor"
        ></div>
      </div>
      <div
        v-for="(item,index) in items.choiceList"
        :key="index"
        :style="{paddingTop: '10px',paddingRight:'30px'}"
      >
        <div :style="{fontSize: '17px',color: 'black',marginBottom:'10px'}">{{ index + 1 }} . {{ item.topic }}
          <a-input
            :style="{marginTop: '10px'}"
            v-model="item.result"
            @change="onChange"
          />
        </div>
      </div>
      <a-divider />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ReadTwoForm',
  data () {
    return {
      visible: false,
      value: {}
    }
  },
  created () {
    // console.log('数据详情：' + JSON.stringify(this.value))
  },
  methods: {
    handleOpen (value) {
      // console.log('数据详情：' + JSON.stringify(value))
      this.visible = true
      this.value = value
    },
    onChange () {
      // console.log('data' + JSON.stringify(this.value))
      this.$emit('resultChange', this.value)
    },
    handleClose () {
      this.visible = false
    }
  }
}
</script>
